// utils/LoadingMessages.ts
import { useEffect, useMemo, useState } from "react";

class LoadingMessages {
	private i = 0;
	constructor(private list: string[]) {}
	next() {
		const msg = this.list[this.i];
		this.i = (this.i + 1) % this.list.length;
		return msg;
	}
}

export const waterMessages = [
	"Filling the oceans...",
	"Unleashing the rivers...",
	"Collecting droplets of data...",
	"Charting the waterways...",
	"Hydrating the planet...",
];

export const initializationMessages = ["Initializing Lens...", "Initializing the Future of Data-driven Water Insights"];

export function useLoadingMessage(messages: string[], loading: boolean, intervalMs = 2000) {
	const rotator = useMemo(() => new LoadingMessages(messages), [messages]);
	const [message, setMessage] = useState(() => rotator.next());

	useEffect(() => {
		if (!loading) return;
		setMessage(rotator.next()); // reset when loading starts
		const id = setInterval(() => setMessage(rotator.next()), intervalMs);
		return () => clearInterval(id);
	}, [loading, rotator, intervalMs]);

	return message;
}
